import classnames from 'classnames';
import PropTypes from 'prop-types';

import CircleSpinner from '../../icon/CircleSpinner';
import styles from './CornerLoader.module.scss';

// Places a loader absolute positioned in the top right corner of it's container
const CornerLoader = ({
  visible = false,
  dark = false,
  inDialog = false,
  corner = 'topRight',
}) => (
  <div
    className={classnames(styles.cornerLoader, {
      [styles.visible]: visible,
      [styles.dark]: dark,
      [styles.light]: !dark,
      [styles.inDialog]: inDialog,
      [styles.topLeft]: corner === 'topLeft',
      [styles.topRight]: corner === 'topRight',
      [styles.bottomLeft]: corner === 'bottomLeft',
      [styles.bottomRight]: corner === 'bottomRight',
    })}
  >
    <CircleSpinner />
  </div>
);

CornerLoader.propTypes = {
  visible: PropTypes.bool,
  dark: PropTypes.bool,
  inDialog: PropTypes.bool,
  corner: PropTypes.oneOf(['topLeft', 'topRight', 'bottomLeft', 'bottomRight']),
};

export default CornerLoader;
